import React from 'react';

export default function Card(props) {
  return (
    <div className="card app-card mb-3" style={props.style}>
      { props.title ? (<h3 className="card-header app-card-title">{props.title}</h3>) : ('') }
      <div className="card-body">
        {props.children}
      </div>
    </div>
  );
}
